import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";

interface Film {
  title: string;
  value: string;
}

function sleep(duration: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, duration);
  });
}

export const AutoCompleteField = ({
  label,
  itemsList = [],
  handleOnChange,
  value,
  fullWidth = false
}: {
  label: string;
  itemsList: any;
  handleOnChange: (data:any) => void;
  value: any;
  fullWidth?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<readonly Film[]>([]);
  const loading = open && options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3); 

      if (active) {
        const optionsWithKeys = itemsList.map((option:any) => ({
          ...option,
          key: option.value
        }));
        setOptions(optionsWithKeys);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading, itemsList]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <Autocomplete
      size="small"
      id={`${label?.replaceAll(" ", "")}`}
      sx={{ width: fullWidth ? '100%': 300 }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => option.title === value.title}
      getOptionLabel={(option) => option.title}
      options={options}
      value={value}
      loading={loading}
      onChange={(event, newValue:any) => {
        handleOnChange(newValue??null);
      }}
      renderInput={(params:any) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};
